import React from 'react';
import styled from 'styled-components';
import { Table } from 'react-bootstrap';
import ListRow from './ListRow';

const Th = styled.th`
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  background-color: ${({ primary, secondary, theme }) => {
    if (primary) return theme.blowGreen;
    if (secondary) return theme.blowWarning;
  }};
  ${({ small }) => (small ? 'font-weight:normal;font-size:12px' : '')}
`;

const ColorSamplesList = ({ order }) => {
  if (order.colorSamplesItems.length)
    return (
      <Table responsive="xl" bordered hover size="sm">
        <thead>
          <tr>
            <Th width="50" rowSpan={2}>
              Lp
            </Th>
            <th rowSpan="2" style={{ width: 200 }}>
              Typ
            </th>
            <Th width="50" rowSpan="4">
              Ilość
            </Th>
            <th rowSpan="2" style={{ width: 600 }}>
              Uwagi
            </th>
          </tr>
        </thead>
        <tbody>
          {order.colorSamplesItems.map((item, index) =>
            item !== null ? (
              <ListRow
                item={item}
                order={order}
                index={index}
                key={item._id || Math.random()}
              />
            ) : null,
          )}
        </tbody>
      </Table>
    );
  return <>Brak próbek kolorów</>;
};

export default ColorSamplesList;
